import * as authServices from 'services/auth';
import * as userServices from 'services/user';
import * as tokenServices from 'services/token';
import queryClient from '../../services/queryClient';
import { ecsExperimentationFramework } from '../../experimentation-framework';

export const REQUEST_STARTED = 'auth/REQUEST_STARTED';
export const REQUEST_COMPLETED = 'auth/REQUEST_SUCCESSFUL';
export const LOGGED_OUT = 'auth/LOGGED_OUT';
export const SET_ERROR = 'auth/SET_ERROR';
export const CLEAR_ERROR = 'auth/CLEAR_ERROR';
export const SET_LOGGED_USER = 'auth/SET_LOGGED_USER';
export const SET_IS_LOGGED_IN = 'auth/SET_IS_LOGGED_IN';

export const setError = error => ({
  type: SET_ERROR,
  error,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export const requestStarted = () => dispatch => {
  dispatch(clearError());
  dispatch({ type: REQUEST_STARTED });
};

export const requestCompleted = () => ({
  type: REQUEST_COMPLETED,
});

export const setLoggedOut = () => {
  tokenServices.clearUserToken();
  tokenServices.removeUser();
  return { type: LOGGED_OUT };
};

export const setLoggedUser = user => {
  tokenServices.setUser(user);
  return { type: SET_LOGGED_USER, user };
};

export const setIsLoggedIn = isLoggedIn => {
  return { type: SET_IS_LOGGED_IN, isLoggedIn };
};

export const logout = () => dispatch => {
  dispatch(requestStarted());
  authServices
    .logout()
    .then(() => {
      dispatch(setLoggedOut());
      dispatch(requestCompleted());
    })
    .catch(error => {
      dispatch(setError(error.message));
      dispatch(requestCompleted());
    });
};

export const setLoginStatus = () => dispatch => {
  const token = tokenServices.getUserToken();
  if (token && token.length > 15) {
    getUserInfo(dispatch).catch(console.error);
  }
};

const getUserInfo = async dispatch => {
  dispatch(requestStarted());
  try {
    const {
      id,
      fullName: name,
      roles,
      permissions,
      email,
      isGuest,
      project,
    } = await queryClient.fetchQuery(['me'], userServices.getCurrentProfile);
    ecsExperimentationFramework.setUser({ id, email, role: roles[0]?.name });
    dispatch(
      setLoggedUser({
        name,
        email,
        role: roles[0]?.name,
        permissions,
        id,
        isGuest,
        projectId: project?.id,
      }),
    );
    dispatch(setIsLoggedIn(true));
  } catch (e) {
    dispatch(setError(e.message));
  } finally {
    dispatch(requestCompleted());
  }
};
